import { Container } from '@mui/material'
import * as React from 'react'
import EmailIcon from '@mui/icons-material/Email';

export const Home = () => {
  const [lightboxImage, setLightboxImage] = React.useState(null);

  const closeLightbox = () => setLightboxImage(null);

  // Handle ESC key for lightbox
  React.useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') closeLightbox(); };
    if (lightboxImage) window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [lightboxImage]);

  const menuImages = [
    { src: process.env.PUBLIC_URL + '/images/90Menu1.png', label: 'Menu 1' },
    { src: process.env.PUBLIC_URL + '/images/90Menu2.png', label: 'Menu 2' },
  ];

  const galleryImages = [
    { src: process.env.PUBLIC_URL + 'images/burger.png', alt: 'Signature smash burger' },
    { src: process.env.PUBLIC_URL + 'images/casaazul.jpeg', alt: 'Casa Azul cocktail' },
    { src: process.env.PUBLIC_URL + 'images/bar.jpeg', alt: 'Interior bar at 90 Proof' },
    { src: process.env.PUBLIC_URL + 'images/flamingmarg.jpg', alt: 'Flaming margarita' },
    { src: process.env.PUBLIC_URL + 'images/queso.jpg', alt: 'Queso and chips' },
    { src: process.env.PUBLIC_URL + 'images/food.jpg', alt: 'Featured dishes' },
  ];

  const hours = [
    { day: 'Monday', time: '12:00 PM – 2:00 AM' },
    { day: 'Tuesday', time: '12:00 PM – 2:00 AM' },
    { day: 'Wednesday', time: '12:00 PM – 2:00 AM' },
    { day: 'Thursday', time: '12:00 PM – 2:00 AM' },
    { day: 'Friday', time: '12:00 PM – 2:00 AM' },
    { day: 'Saturday', time: '12:00 PM – 2:00 AM' },
    { day: 'Sunday', time: '12:00 PM – 2:00 AM' },
  ];

  return (
    <div style={{ padding: 0, margin: 0, overflow: 'hidden' }}>
      {/* HERO — new premium look */}
      <section className="hero" id="top">
        <img
          src={process.env.PUBLIC_URL + "images/90proof.jpeg"}
          alt="90 Proof Bar & Grill exterior"
          style={{ objectPosition: 'center 35%' }}
        />
        <div className="hero-overlay" />
        <div className="hero-content">
          <div style={{ color: '#c5a26f', letterSpacing: '6px', fontSize: '0.95rem', marginBottom: 4 }}>EST. 2022 • 21+</div>
          <h1>90 PROOF</h1>
          <div className="subtitle">BAR &amp; GRILL</div>
          <p className="tagline">Veteran-owned neighborhood spot in San Antonio serving great food, high-end tequila, and cold drinks in a laid-back atmosphere.</p>
          <div className="hero-ctas">
            <a href="#menu" className="btn primary">VIEW MENU</a>
            <a href="#location" className="btn">VISIT US</a>
            <a
              href="https://www.doordash.com/store/90-proof-bar-grill-san-antonio-27592730/"
              target="_blank"
              rel="noreferrer"
              className="btn"
            >
              ORDER ONLINE
            </a>
          </div>
        </div>
      </section>

      {/* INTRO */}
      <section className="section" style={{ background: '#111' }}>
        <Container>
          <div style={{ maxWidth: 720, margin: '0 auto', textAlign: 'center' }}>
            <p style={{ fontSize: '1.1rem', color: '#ccc', margin: 0 }}>
              Located off Hwy 90, 90 Proof is your go-to for smash burgers, daily specials, happy hour (3–6 PM), live trivia, game-day deals, and an excellent selection of premium spirits.
            </p>
          </div>
        </Container>
      </section>

      {/* MENU — new look with lightbox */}
      <section id="menu" className="section" style={{ background: 'var(--bg)' }}>
        <Container>
          <h2 className="section-title">Menus</h2>

          <div className="menu-wrap">
            {menuImages.map((m, idx) => (
              <div key={idx} className="menu-col">
                <div
                  onClick={() => setLightboxImage(m.src)}
                  style={{ cursor: 'zoom-in' }}
                  title="Click to enlarge"
                >
                  <img
                    src={m.src}
                    alt={m.label}
                    className="menu-image"
                    loading="lazy"
                  />
                </div>
                <div style={{ textAlign: 'center', marginTop: 10, fontSize: '0.8rem', color: 'var(--text-muted)', letterSpacing: '1px' }}>
                  FOOD &amp; DRINK MENU — CLICK TO ENLARGE
                </div>
              </div>
            ))}
          </div>

          <div style={{ textAlign: 'center', marginTop: 32, fontSize: '0.85rem', color: 'var(--text-muted)' }}>
            Menus subject to change. Ask your server about daily specials and happy hour pricing.
          </div>
        </Container>
      </section>

      {/* GALLERY / VIBES — new visual section using existing assets */}
      <section className="section" style={{ background: '#111', paddingTop: 40, paddingBottom: 60 }}>
        <Container>
          <h2 className="section-title" style={{ marginBottom: 24 }}>The Vibes</h2>
          <div className="gallery">
            {galleryImages.map((img, i) => (
              <img key={i} src={img.src} alt={img.alt} loading="lazy" />
            ))}
          </div>
        </Container>
      </section>

      {/* LOCATION + HOURS — improved, accurate address */}
      <section id="location" className="section">
        <Container>
          <h2 className="section-title">Visit 90 Proof</h2>

          <div className="info-grid">
            {/* Info side */}
            <div>
              <div style={{ marginBottom: 28 }}>
                <div className="copperColor" style={{ letterSpacing: 1, fontSize: '0.85rem', marginBottom: 6 }}>ADDRESS</div>
                <a
                  href="https://goo.gl/maps/NBEF1seiiqLiz9Pu7"
                  target="_blank"
                  rel="noreferrer"
                  className="linkDestyle"
                  style={{ fontSize: '1.1rem', lineHeight: 1.3 }}
                >
                  11880 W US Hwy 90, Ste 110<br />
                  San Antonio, TX 78245
                </a>
              </div>

              <div style={{ marginBottom: 28 }}>
                <div className="copperColor" style={{ letterSpacing: 1, fontSize: '0.85rem', marginBottom: 6 }}>PHONE</div>
                <a href="tel:2104449990" className="linkDestyle" style={{ fontSize: '1.15rem' }}>(210) 444-9990</a>
              </div>

              <div>
                <div className="copperColor" style={{ letterSpacing: 1, fontSize: '0.85rem', marginBottom: 10 }}>HOURS — DAILY</div>
                <ul className="hours-list">
                  {hours.map((h, i) => (
                    <li key={i}>
                      <span>{h.day}</span>
                      <span style={{ color: 'var(--text-muted)' }}>{h.time}</span>
                    </li>
                  ))}
                </ul>
                <div style={{ fontSize: '0.8rem', color: 'var(--text-muted)', marginTop: 8 }}>
                  21+ only • Happy Hour 3 PM – 6 PM daily
                </div>
              </div>

              <div className="order-options">
                <div className="order-card">
                  <div style={{ fontSize: '0.75rem', color: 'var(--text-muted)', marginBottom: 6 }}>DELIVERY / TAKEOUT</div>
                  <a href="https://www.doordash.com/store/90-proof-bar-grill-san-antonio-27592730/" target="_blank" rel="noreferrer">
                    Order on DoorDash →
                  </a>
                </div>
              </div>
            </div>

            {/* Map */}
            <div className="map-container">
              <iframe
                title="90 Proof Bar & Grill location"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3476.8258188360533!2d-98.7304803479412!3d29.37538885673068!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x865c4531f56c6139%3A0x8edc3f132f9a30cc!2s90%20Proof%20Bar%20%26%20Grill!5e0!3m2!1sen!2sus!4v1672868726797!5m2!1sen!2sus"
                width="100%"
                height="380"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
          </div>
        </Container>
      </section>

      {/* CONTACT */}
      <section id="contact" className="section" style={{ background: '#111', paddingTop: 60, paddingBottom: 80 }}>
        <Container>
          <div style={{ textAlign: 'center' }}>
            <h2 className="section-title" style={{ marginBottom: 16 }}>Get In Touch</h2>
            <div style={{ marginBottom: 16 }}>
              <EmailIcon style={{ fontSize: 42, color: 'var(--accent)' }} />
            </div>
            <p style={{ maxWidth: 420, margin: '0 auto 8px', color: '#ccc' }}>
              For all inquiries, private events, or questions please reach out.
            </p>
            <a
              href="mailto:contact@therustynailsa.com"
              className="linkDestyle copperColor"
              style={{ fontSize: '1.05rem', fontWeight: 500 }}
            >
              contact@therustynailsa.com
            </a>
          </div>
        </Container>
      </section>

      {/* LIGHTBOX for menu images — pure React, no extra deps */}
      {lightboxImage && (
        <div
          onClick={closeLightbox}
          style={{
            position: 'fixed',
            inset: 0,
            background: 'rgba(0,0,0,0.92)',
            zIndex: 9999,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: 20,
            cursor: 'zoom-out'
          }}
        >
          <div onClick={(e) => e.stopPropagation()} style={{ position: 'relative', maxWidth: '94vw', maxHeight: '92vh' }}>
            <button
              onClick={closeLightbox}
              style={{
                position: 'absolute',
                top: -12,
                right: -12,
                background: '#111',
                color: '#fff',
                border: '1px solid #444',
                width: 36,
                height: 36,
                borderRadius: '50%',
                fontSize: 20,
                lineHeight: 1,
                cursor: 'pointer'
              }}
              aria-label="Close menu preview"
            >
              ×
            </button>
            <img
              src={lightboxImage}
              alt="Menu preview"
              style={{ maxWidth: '100%', maxHeight: '92vh', height: 'auto', boxShadow: '0 10px 60px rgba(0,0,0,0.7)', border: '1px solid #222' }}
            />
          </div>
        </div>
      )}
    </div>
  );
};

